import { CommonModule } from '@angular/common';
import {
  AfterContentInit,
  Component,
  ContentChild,
  ContentChildren,
  EventEmitter,
  Input,
  Output,
  QueryList,
  TemplateRef,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { MenuModule } from 'primeng/menu';
import {
  ExportButtonComponent,
  ExportFormat,
} from '../buttons/export-button.component';
import { ToggleSwitchComponent } from '../controls/toggle-switch.component';
import { ActionRowComponent } from './action-row.component';
import { CardComponent } from './card.component';

@Component({
  selector: 'app-toggle-panel',
  imports: [
    MenuModule,
    CommonModule,
    ToggleSwitchComponent,
    ExportButtonComponent,
    ActionRowComponent,
  ],
  template: `
    <div class="tw-flex tw-justify-between tw-items-center tw-w-full tw-pb-2">
      <div>
        <ng-container *ngTemplateOutlet="leftTemplate"></ng-container>
      </div>
      <app-action-row>
        @if (showExpand) {
          <app-toggle-switch
            label="Expand all"
            [control]="expandAll"
            [showHelpText]="false"
            (click)="toggle()"
            right1
          />
        }
        @if (export) {
          <app-export-button
            right2
            (export)="onExport($event)"
          ></app-export-button>
        }
      </app-action-row>
    </div>
    <ng-content></ng-content>
  `,
  styles: `
    :root {
      --p-menu-background: red;
    }
  `,
})
export class TogglePanelComponent implements AfterContentInit {
  @ContentChildren(CardComponent, { descendants: true })
  panels: QueryList<CardComponent>;

  @ContentChild('left')
  leftTemplate: TemplateRef<any>;

  expandAll = new FormControl<boolean>(false);

  @Input()
  export = false;

  @Input()
  showExpand = true;

  @Input()
  expanded = false;

  @Output()
  exportEvent = new EventEmitter<ExportFormat>();

  ngAfterContentInit(): void {
    if (this.expanded) {
      this.expandAll.setValue(true);
      this.toggle();
    }
  }

  toggle(): void {
    for (const panel of this.panels) {
      panel.expanded = this.expandAll.value;
    }
    if (!this.expandAll.value) {
      this.panels.first.expanded = true;
    }
  }
  onExport(format: ExportFormat) {
    this.exportEvent.emit(format);
  }
}
